export const WEATHER_PARAMS: string[] = [
	'Beau temps',
	'Temps nuageux',
	'Temps pluvieux',
	'Temps neigeux',
	'Beau temps',
	'Temps nuageux',
];

export const WEATHER_PARAMS_ICONS: string[] = [
	'wb_sunny',
	'filter_drama',
	'flash_on',
	'ac_unit',
	'wb_sunny',
	'filter_drama',
];
